'use strict';

var util = require('./util');

var wizard = {
    init: function () {
        $('body').on('click', '.c-wizard .js-action', function (e) {
            let $action = $(this);

            if ($action.hasClass('disabled')) {
                return;
            }
            if ($action.hasClass('js-action-toggle')) {
                $action.toggleClass('inactive');
                $action.toggleClass('active');
                let $target = $($action.data('target'));
                if ($target.length) {
                    $target.toggleClass('inactive');
                    $target.toggleClass('active');
                }
                return;
            }

            let $wizard = $action.closest('.c-wizard');

            if ($action.hasClass('js-action-direct')) {
                $wizard.addClass('js-action-loading');
                window.location.href = $action.data('href');
                return;
            }
            $wizard.addClass('js-action-load-starting');
            let ajaxUrl = $action.data('href');
            $.ajax({
                type: 'GET',
                url: util.ajaxUrl(ajaxUrl)
            }).done(function (data) {
                $wizard.replaceWith(data);
            }).fail(function () {
                $wizard.removeClass('js-action-load-starting').removeClass('js-action-loading');
            });
            setTimeout(function () {
                // only show the loading indicator if the request takes more than 200ms
                if ($wizard && $wizard.hasClass('js-action-load-starting')) {
                    $wizard.removeClass('js-action-load-starting').addClass('js-action-loading');
                }
            }, 200);
        });
    }
};

module.exports = wizard;
